import { de } from '../i18n/de';
import { useStoryEnv } from '../state/storyEnv';

/**
 * Name der Geschichte, oben über der Seitenleiste (Bibliothek, Handlung) bzw. über dem Binder (Manuskript); als Episode einer Serie mit
 * gemeinsamer Bibliothek darunter ihre Stelle (PLAN.md §43).
 */
export function ProjectName() {
  const { story } = useStoryEnv();
  const series = story.series;
  return (
    <h1 className="project-name" title={story.project.name} data-testid="project-title">
      {story.project.name}
      {series && (
        <span className="project-episode" data-testid="project-episode">
          {de.series.episodeOf(series.number, series.count, series.name)}
        </span>
      )}
    </h1>
  );
}
